<template>
  <div id="fcs">
    <!-- item -->
    <div class="item" v-if="item">
      <div class="item-text">
        <h1 class="title">{{ item.key }}</h1>
        <div class="text" v-html="imageFixingUrl(item.body)"></div>
        <span @click="$router.back()" class="back-to">{{t.back}}</span>
      </div>
    </div>
    <!--  /end item -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["t", "announcements", "imageFixingUrl"]),
    item() {
      return this.announcements.find(item => {
        return this.$route.params.id == item.id;
      });
    }
  },
  watch: {
    // keepalive fixing scroll animate
    item(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.focusContent();
      }
    }
  },
  methods: {
    focusContent() {
      let set;
      clearTimeout(set);
      const _ = this;
      set = setTimeout(() => {
        _.$scrollTo("#fcs");
      }, 100);
    }
  },
  mounted() {
    this.focusContent();
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/colors";
@import "../../styles/announcements_partner";
</style>

